import React from "react";
import { useSelector } from "react-redux";
import { isProductsFetching } from "../../redux/QuoteSelectors";
import { useTranslation } from "react-i18next";
import { Button, Skeleton } from "antd";
import baseTheme from "../../../../config/baseTheme";
import styled from "styled-components";

// Notes: Esta lista fue hecha exclusivamente para Alborde, no cumple ningun standard de calidad de código. Siento verguenza por haber escrito esto, pero verguenza es robar.

const Section = styled.div`
  margin-top: 10px;
  font-size: 12px;
  font-weight: 600;
`;

const SnowCategoriesList = ({ onClick }) => {
  const { t } = useTranslation();
  const isFetching = useSelector(isProductsFetching);

  if (isFetching) {
    return <Skeleton active title paragraph={{ rows: 10 }} />;
  }

  return (
    <div>
      <Section>Equipos</Section>
      <Button
        key={"ski"}
        style={{
          alignSelf: "start",
          width: "100%",
          textAlign: "left",
          margin: 0,
          borderBottom: `1px solid ${baseTheme.borders.gray}`,
          borderRadius: 0,
          height: 40,
        }}
        type="link"
        size="regular"
        onClick={() => onClick("ski")}
      >
        {t(`categoriesList.ski_alt`)}
      </Button>
      <Button
        key={"bootsSki"}
        style={{
          alignSelf: "start",
          width: "100%",
          textAlign: "left",
          margin: 0,
          borderBottom: `1px solid ${baseTheme.borders.gray}`,
          borderRadius: 0,
          height: 40,
        }}
        type="link"
        size="regular"
        onClick={() => onClick("bootsSki")}
      >
        {t(`categoriesList.bootsSki`)}
      </Button>
      <Button
        key={"skiSticks"}
        style={{
          alignSelf: "start",
          width: "100%",
          textAlign: "left",
          margin: 0,
          borderBottom: `1px solid ${baseTheme.borders.gray}`,
          borderRadius: 0,
          height: 40,
        }}
        type="link"
        size="regular"
        onClick={() => onClick("skiSticks")}
      >
        {t(`categoriesList.skiSticks`)}
      </Button>
      <Button
        key={"snowboard"}
        style={{
          alignSelf: "start",
          width: "100%",
          textAlign: "left",
          margin: 0,
          borderBottom: `1px solid ${baseTheme.borders.gray}`,
          borderRadius: 0,
          height: 40,
        }}
        type="link"
        size="regular"
        onClick={() => onClick("snowboard")}
      >
        {t(`categoriesList.snowboard_alt`)}
      </Button>
      <Button
        key={"bootsSnowboard"}
        style={{
          alignSelf: "start",
          width: "100%",
          textAlign: "left",
          margin: 0,
          borderBottom: `1px solid ${baseTheme.borders.gray}`,
          borderRadius: 0,
          height: 40,
        }}
        type="link"
        size="regular"
        onClick={() => onClick("bootsSnowboard")}
      >
        {t(`categoriesList.bootsSnowboard`)}
      </Button>
      <Button
        key={"helmets"}
        style={{
          alignSelf: "start",
          width: "100%",
          textAlign: "left",
          margin: 0,
          borderBottom: `1px solid ${baseTheme.borders.gray}`,
          borderRadius: 0,
          height: 40,
        }}
        type="link"
        size="regular"
        onClick={() => onClick("helmets")}
      >
        {t(`categoriesList.helmets`)}
      </Button>
      <Button
        key={"goggles"}
        style={{
          alignSelf: "start",
          width: "100%",
          textAlign: "left",
          margin: 0,
          borderBottom: `1px solid ${baseTheme.borders.gray}`,
          borderRadius: 0,
          height: 40,
        }}
        type="link"
        size="regular"
        onClick={() => onClick("goggles")}
      >
        {t(`categoriesList.goggles`)}
      </Button>
      <Button
        key={"sleds"}
        style={{
          alignSelf: "start",
          width: "100%",
          textAlign: "left",
          margin: 0,
          borderBottom: `1px solid ${baseTheme.borders.gray}`,
          borderRadius: 0,
          height: 40,
        }}
        type="link"
        size="regular"
        onClick={() => onClick("sleds")}
      >
        {t(`categoriesList.sleds`)}
      </Button>
      <Button
        key={"snowshoes"}
        style={{
          alignSelf: "start",
          width: "100%",
          textAlign: "left",
          margin: 0,
          borderBottom: `1px solid ${baseTheme.borders.gray}`,
          borderRadius: 0,
          height: 40,
        }}
        type="link"
        size="regular"
        onClick={() => onClick("snowshoes")}
      >
        {t(`categoriesList.snowshoes`)}
      </Button>
      <Section>Indumentaria</Section>
      <Button
        key={"jackets"}
        style={{
          alignSelf: "start",
          width: "100%",
          textAlign: "left",
          margin: 0,
          borderBottom: `1px solid ${baseTheme.borders.gray}`,
          borderRadius: 0,
          height: 40,
        }}
        type="link"
        size="regular"
        onClick={() => onClick("jackets")}
      >
        {t(`categoriesList.jackets`)}
      </Button>
      <Button
        key={"trousers"}
        style={{
          alignSelf: "start",
          width: "100%",
          textAlign: "left",
          margin: 0,
          borderBottom: `1px solid ${baseTheme.borders.gray}`,
          borderRadius: 0,
          height: 40,
        }}
        type="link"
        size="regular"
        onClick={() => onClick("trousers")}
      >
        {t(`categoriesList.trousers`)}
      </Button>
      <Button
        key={"gloves"}
        style={{
          alignSelf: "start",
          width: "100%",
          textAlign: "left",
          margin: 0,
          borderBottom: `1px solid ${baseTheme.borders.gray}`,
          borderRadius: 0,
          height: 40,
        }}
        type="link"
        size="regular"
        onClick={() => onClick("gloves")}
      >
        {t(`categoriesList.gloves`)}
      </Button>
      <Button
        key={"bootsApreski"}
        style={{
          alignSelf: "start",
          width: "100%",
          textAlign: "left",
          margin: 0,
          borderBottom: `1px solid ${baseTheme.borders.gray}`,
          borderRadius: 0,
          height: 40,
        }}
        type="link"
        size="regular"
        onClick={() => onClick("bootsApreski")}
      >
        {t(`categoriesList.bootsApreski`)}
      </Button>
      <Section>Otros</Section>
      <Button
        key={"accessories"}
        style={{
          alignSelf: "start",
          width: "100%",
          textAlign: "left",
          margin: 0,
          borderBottom: `1px solid ${baseTheme.borders.gray}`,
          borderRadius: 0,
          height: 40,
        }}
        type="link"
        size="regular"
        onClick={() => onClick("accessories")}
      >
        {t(`categoriesList.accessories`)}
      </Button>
    </div>
  );
};

export default SnowCategoriesList;
